<div
  [pTooltip]="'Confidence: ' + getConfidenceLevel() + '%'"
  class="confidence-indicator"
  tooltipPosition="top"
>
  @for (level of levels; track level) {
    <div
      [style.background]="getGradient(level)"
      class="step"
    ></div>
  }
</div>
